import { render, staticRenderFns } from "./addOutOfStock.vue?vue&type=template&id=3fef7edd&scoped=true"
import script from "./addOutOfStock.vue?vue&type=script&lang=js"
export * from "./addOutOfStock.vue?vue&type=script&lang=js"
import style0 from "./addOutOfStock.vue?vue&type=style&index=0&id=3fef7edd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef7edd",
  null
  
)

export default component.exports